module.exports = __webpack_public_path__ + "img/PY.9b4f849f.svg";